// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.feature.FeatureFlagEmployeeSummaryResponse */
/* istanbul ignore next */
@GandalfModel
export class FeatureFlagEmployeeSummaryResponse extends GandalfModelBase {

	@GandalfConstantDecorator(constants.FeatureFlagAccess)
	@GandalfProperty({ designType: constants.FeatureFlagAccess })
	access!: constants.FeatureFlagAccess | null;

	@GandalfProperty({ designType: Number })
	employeeId!: number | null;

	@GandalfProperty({ designType: Number })
	featureFlagId!: number | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

}
